import React from "react";
import ReactDOM from "react-dom";
import { Section, Box, Heading, Paragraph, Image, Video } from "grommet";

import video from "./video.mp4";
import screenshot from "./screenshot.jpg";

const ColonialKartWorld = props => (
  <Section colorIndex={props.colorIndex} pad="medium" align="center">
    {!props.responsive ? (
      <Heading tag="h2" strong={true} margin="small">
        Colonial Kart World
      </Heading>
    ) : null}
    <Box direction="row" size={{ width: "xxlarge" }}>
      <Box
        direction="column"
        basis="2/3"
        margin="small"
        textAlign="left"
        align="center"
      >
        <Image src={screenshot} size="medium" />
        <Paragraph>
          Colonial Kart World is a team based high seas frag fest with crazy
          physics. I made it in Unity over 2 days for a Ludum Dare competition.
          Ludum Dare is a popular game jam where developers complete a game
          within 72 hours. For this competition I challenged myself extra by
          generating the games name randomly with an online name generation tool
          and building a game to match it. That's where the title 'Colonial Kart
          World' came from. The tool I used is:{" "}
          <a href="https://videogamena.me/">https://videogamena.me/</a>
        </Paragraph>
        <Paragraph>
          I used a few 3rd party assets to make the game in a short time. The
          sky, sound effects and particle effects are assets I had already
          bought from the asset store. The ocean is an open source project
          available{" "}
          <a href="https://github.com/eliasts/Ocean_Community_Next_Gen">here</a>,
          I recommend it as it has an impressive amount of features. Everything
          else I managed to squeeze in during a weekend. My favourite part was
          programming the bouyancy of the ships and experimenting with waves
          that can launch them into the air!
        </Paragraph>
      </Box>
      <Box direction="column" basis="1/3" justify="left" textAlign="left">
        <Paragraph>
          I was pretty happy with the results and although it lacked polish I
          got a lot of good feedback that it was a fun game. It's been
          especially popular on some free web games sites where it has hundreds
          of thousands of plays.
        </Paragraph>
        <Video size="small">
          <source src={video} type="video/mp4" />
        </Video>
        <Paragraph size="small">
          Play it in your browser{" "}
          <a href="https://adamalexandr.itch.io/colonial-kart-world">here</a>
        </Paragraph>
      </Box>
    </Box>
  </Section>
);

export default ColonialKartWorld;



// WEBPACK FOOTER //
// ./src/components/projects/colonial-kart-world/colonial-kart-world.js